import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../../services/util/error.service'
import { getUsuarioInfo } from '../../../../../services/localstorage/localstorage.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_POSICOES: 'Carregando posições',
  DESASSOC_POS: 'Associando posições ao inventario',
  CREATE_CONF: 'Criando conferencia das posições selecionadas',
  FINALIZAR_CONF: 'Finalizando conferencia da posição',
  ZERAR_POSICOES: 'Zerando posições restantes',
}

const MODAL_MODE = {
  HISTORICO: 'history',
  CONTAGEM_MANUAL: 'manual',
}

const INITIAL_STATE = {
  posicoes: [],
  selectedPosicoes: [],
  selectedPosicao: null,
  pathToRedirect: null,
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  modal: {
    show: false,
    data: null,
    mode: null,
  },
  confirmZerarPosicoes: {
    show: false,
  },
  successMessage: null,
  totalConferido: 0,
  totalNaoConferido: 0,
  percentage: 0,
}

export default function usePosicoesAssociadas() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    const calculateStatistics = posicoes => {
      const totalConferido = posicoes.filter(p => p.status === 'Conferido').length
      const totalNaoConferido = posicoes.filter(p => p.status === 'Em Conferência').length
      const total = totalConferido + totalNaoConferido
      const percentage = total > 0 ? ((totalConferido / total) * 100).toFixed(2) : 0

      return {
        totalConferido,
        totalNaoConferido,
        percentage: parseFloat(percentage),
      }
    }

    return {
      getPosicoesToAssoc(selectedTp, inventario_id) {
        EstoqueHttp.getPosicoesEstoqueAssoc(selectedTp, inventario_id)
          .then(res => {
            const statistics = calculateStatistics(res)
            setState(prevState => ({
              ...prevState,
              posicoes: res,
              selectedPosicoes: [],
              loadingMessage: LOAD_MESSAGE.NONE,
              ...statistics,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      desassocPosicoesToInventario(selectedTp, selectedInventarioId, selectedPosicoes) {
        EstoqueHttp.desassociarPosicoesToInventario(
          selectedTp,
          selectedInventarioId,
          selectedPosicoes.map(p => p.posicao_estoque_id),
        )
          .then(res => {
            const statistics = calculateStatistics(res)
            setState(prevState => ({
              ...prevState,
              successMessage: 'Posições desassociadas com sucesso',
              posicoes: res,
              selectedPosicoes: [],
              loadingMessage: LOAD_MESSAGE.NONE,
              ...statistics,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      createConferenciaFromPosicoes(selectedTp, selectedInventarioId, selectedPosicoes) {
        EstoqueHttp.createConferenciaInventarioFromPosicoes(
          selectedTp,
          selectedInventarioId,
          selectedPosicoes.map(p => p.posicao_estoque_id),
        )
          .then(res => {
            const statistics = calculateStatistics(res)
            setState(prevState => ({
              ...prevState,
              successMessage: `${selectedPosicoes.length > 1 ? 'Conferências geradas' : 'Conferência gerada'} com sucesso`,
              posicoes: res,
              selectedPosicoes: [],
              loadingMessage: LOAD_MESSAGE.NONE,
              ...statistics,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      finalizarConferenciaDaPosicao(selectedTp, selectedInventarioId, selectedPosicaoId) {
        EstoqueHttp.finalizarConferenciaInventarioFromPosicao(
          selectedTp,
          selectedInventarioId,
          selectedPosicaoId,
        )
          .then(res => {
            const statistics = calculateStatistics(res)
            setState(prevState => ({
              ...prevState,
              successMessage: 'Conferencia finalizada com sucesso',
              posicoes: res,
              selectedPosicao: null,
              selectedPosicoes: [],
              loadingMessage: LOAD_MESSAGE.NONE,
              ...statistics,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      zerarPosicoesRestantes(selectedTp, inventarioId) {
        const { id: userId } = getUsuarioInfo()
        EstoqueHttp.zerarPosicoesRestantes(selectedTp, inventarioId, userId)
          .then(res => {
            const statistics = calculateStatistics(res)
            setState(prevState => ({
              ...prevState,
              successMessage: 'Posições restantes zeradas com sucesso',
              posicoes: res,
              selectedPosicoes: [],
              loadingMessage: LOAD_MESSAGE.NONE,
              ...statistics,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getMenuItems() {
        return ['Histórico Conferência']
      },

      //Actions

      onInit(selectedTp) {
        if (selectedTp) {
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.GET_POSICOES,
          }))
        } else {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        }
      },

      onChange(name, value) {
        setState(prevState => {
          prevState[name] = value
          return { ...prevState }
        })
      },

      onClickAssocPos(posicoes) {
        if (!posicoes.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione pelo menos uma posição para associar',
          }))
        else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.ASSOC_POS }))
      },

      onMenuItemClicked(item, posicao) {
        setState(prevState => {
          switch (item) {
            case 'Histórico Conferência':
              prevState.modal = { show: true, data: posicao, mode: MODAL_MODE.HISTORICO }
              break
            case 'Inserir Contagem':
              prevState.modal = { show: true, data: posicao, mode: MODAL_MODE.CONTAGEM_MANUAL }
              break
            case 'Finalizar Conferência':
              prevState.selectedPosicao = posicao
              prevState.loadingMessage = LOAD_MESSAGE.FINALIZAR_CONF
              break
            default:
              break
          }
          return { ...prevState }
        })
      },

      onClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: null, mode: null } }))
      },

      onClickDesassocPos(selectedPosicoes) {
        if (!selectedPosicoes.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione pelo menos uma posição para desassociar',
          }))
        else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.DESASSOC_POS }))
      },

      onClickCreateConferencia(selectedPosicoes) {
        if (!selectedPosicoes.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione pelo menos uma posição para gerar a conferencia',
          }))
        else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.CREATE_CONF }))
      },

      onClickZerarPosicoes() {
        setState(prevState => ({
          ...prevState,
          confirmZerarPosicoes: { show: true },
        }))
      },

      onCancelZerarPosicoes() {
        setState(prevState => ({
          ...prevState,
          confirmZerarPosicoes: { show: false },
        }))
      },

      onConfirmZerarPosicoes() {
        setState(prevState => ({
          ...prevState,
          confirmZerarPosicoes: { show: false },
          loadingMessage: LOAD_MESSAGE.ZERAR_POSICOES,
        }))
      },

      onClickAnalise(inventario) {
        setState(prevState => ({
          ...prevState,
          pathToRedirect: '/main/estoque/inventario-analise-resultado',
          selectedInventario: inventario,
        }))
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          successMessage: null,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
